import React from "react";
const SecurityStripString = `                             

8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                               
                               
8888888b.           8888888b.  
888  "Y88b          888  "Y88b 
888    888          888    888 
888    888  .d88b.  888    888 
888    888 d88""88b 888    888 
888    888 888  888 888    888 
888  .d88P Y88..88P 888  .d88P 
8888888P"   "Y88P"  8888888P"  
                                                    
                               
                         
                                             
`;
const SecurityStrip = ({ className, isPrimaryColor, smallScreen }) => {
  return (
    <div
      className={`whitespace-pre font-mono font-bold text-[4px] xl:text-[6px] tracking-wider ${className}`}
      style={{
        color: isPrimaryColor
          ? "rgba(255, 210, 0, 0.5)"
          : "rgba(158, 141, 226, 0.75)",
        marginTop: !smallScreen && "60vh",
      }}
    >
      {SecurityStripString}
    </div>
  );
};

SecurityStrip.defaultProps = {
  isPrimaryColor: true,
};
export default SecurityStrip;
